import { Grid } from '@material-ui/core';
import React from 'react';
import { getSingleAdminUserData } from 'Actions/adminActions';
import CloseBtn from '../CloseBtn';
import Logo from '../Logo/';
import { API_ROOT } from '../../../../../../../../api/Routes';
import styled from 'styled-components';
import Person from '@material-ui/icons/Person';
import connect from 'react-redux/es/connect/connect';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import { Formik } from 'formik';
import makeSchema from './validationSchema';
import API from './api';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const UserProfileWrapper = styled.div`
  width: 400px;
  // min-height: 400px;
  overflow-x: hidden;
  background-color: #e0e1e0;
  padding: 40px;
`;
const EditProfileWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0px;
`;
const UserProfileTitle = styled.div`
  padding-top: ${props => (props.addPaddingTop ? '15px' : '0')};
  color: #61717a;
  font-size: 12px;
`;
const UserProfileDataItemColorDiv = styled.div`
  color: #61717a;
  padding-bottom: 5px;
`;
const UserProfileDataItemColorSpan = styled.span`
  color: black;
`;
const UserProfileValue = styled(Input)`
  color: #102027 !important;
  font-size: 14px !important;
`;
const UserProfileValueNotEditable = styled.div`
  color: #102027;
  font-size: 14px;
  padding-top: 7px;
`;
const StyledSelect = styled(Select)`
  color: #102027 !important;
  font-size: 14px !important;
`;
const ButtonWrapper = styled.div`
  height: ${props => (props.nofullHeight ? 'unset' : '100%')};
  padding-top: ${props => (props.nofullHeight ? '15px' : '0')};
  display: flex;
  align-items: center;
`;
const UserProfileData = styled(Grid)`
  display: flex;
  padding: 20px;
`;
const UserProfileDataItem = styled(Grid)`
  &&& {
    margin-bottom: 12px;
  }
`;
const PersonIco = styled(Person)`
  &&& {
    width: 11.5rem;
    height: 11.5rem;
    object-fit: cover;
  }
`;
const ButtonDeactivate = styled(Button)`
  margin-right: 10px !important;
`;

const FieldError = styled.div`
  font-size: 0.75rem;
  color: red;
  font-weight: 300;
`;
const ApproveMsg = styled.div`
  // color: #102027;
  color: #f44336;
  font-size: 14px;
  padding-top: 7px;
  padding-bottom: 7px;
`;

class UserProfile extends React.Component {
  state = {
    open: false,
    message: '',
  };
  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.props.getSingleAdminUserData(
        this.props.userId,
        this.props.companyId
      );
    }
  }

  componentDidMount() {
    this.props.getSingleAdminUserData(this.props.userId, this.props.companyId);
  }

  makeInitialValues = data => {
    if (data.length === 0) return false;
    let initialState = {};
    if (data.enumWorkrole.includes('designer')) {
      initialState = {
        firstName: data.firstName,
        lastName: data.lastName,
        companyName: data.companyName,
        email: data.email,
        mobile: data.mobile,
        mobileNumber: data.mobileNumber,
        workrole: data.workrole,
        userAddress: data.userAddress,
        username: data.username,
      };
      return initialState;
    } else {
      initialState = {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        mobile: data.mobile,
        mobileNumber: data.mobileNumber,
        workrole: data.workrole,
        userAddress: data.userAddress,
        username: data.username,
        companyName: data.companyName,
      };
      return initialState;
    }
  };

  updateUser = values => {
    if (this.props.currentUser.enumWorkrole.includes('designer')) {
      const arupUserId = this.props.currentUser.userId;
      let arupProfile = {
        address: values.userAddress,
        contactEmail: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.mobile,
        mobileNumber: values.mobileNumber,
        role: values.workrole,
        username: values.username,
        companyName: values.companyName,
      };
      API.updateArupUser(arupUserId, arupProfile)
        .then(res => {
          if (res) {
            this.setState(
              {
                message: 'Profile updated',
              },
              () => {
                this.setState({ open: true });
              }
            );
          }
        })
        .catch(err => {
          this.setState({
            open: true,
            message: err.response.data.message,
          });
        });
    } else {
      const companyId = this.props.currentUser.companyId;
      const userId = this.props.currentUser.userId;
      let companyProfile = {
        address: values.userAddress,
        contactEmail: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.mobile,
        mobileNumber: values.mobileNumber,
        role: values.workrole,
        username: values.username,
        companyName: values.companyName,
      };
      API.updateCompanyUser(companyId, userId, companyProfile)
        .then(res => {
          this.setState(
            {
              message: 'Profile updated',
            },
            () => {
              this.setState({ open: true });
            }
          );
        })
        .catch(err => {
          this.setState({
            open: true,
            message: err.response.data.message,
          });
        });
    }
  };

  handleChange = (setFieldValue, type) => e => {
    setFieldValue(type, e.target.value);
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      onClose,
      currentUser,
      arupUsers,
      userId,
      companyId,
      status,
      email,
      registrationLink,
    } = this.props;
    const values = this.makeInitialValues(currentUser);
    return (
      <UserProfileWrapper>
        <CloseBtn onClick={onClose} />
        {currentUser.profileImageId ? (
          <EditProfileWrapper>
            <Logo image={`${API_ROOT}/asset/${currentUser.profileImageId}`} />
          </EditProfileWrapper>
        ) : (
          <EditProfileWrapper>
            <PersonIco />
          </EditProfileWrapper>
        )}
        <UserProfileData container spacing={8}>
          {status === 'Pending' && (
            <UserProfileDataItem item xs={12}>
              <UserProfileDataItemColorDiv>
                User email:{' '}
                <UserProfileDataItemColorSpan>
                  {email}
                </UserProfileDataItemColorSpan>
              </UserProfileDataItemColorDiv>
              <UserProfileDataItemColorDiv>
                Registration link:{' '}
                <UserProfileDataItemColorSpan>
                  {registrationLink}
                </UserProfileDataItemColorSpan>
              </UserProfileDataItemColorDiv>
              {/* Steps to re-send invitation email:
              <p>-Delete this invitation</p>
              <p>-Send New invitation from invitation bar</p> */}
              <UserProfileTitle addPaddingTop={true}>
                Action on user
              </UserProfileTitle>
              <ButtonWrapper nofullHeight={true}>
                <ButtonDeactivate
                  fullWidth
                  variant="contained"
                  color="primary"
                  // disabled={status !== 'Active' && status !== 'Deactivated'}
                  onClick={this.props.trigerOpenDeleteDialog(email)}
                >
                  Delete invitation
                </ButtonDeactivate>
              </ButtonWrapper>
              <ButtonWrapper nofullHeight={true}>
                <ButtonDeactivate
                  fullWidth
                  variant="contained"
                  color="primary"
                  // disabled={status !== 'Active' && status !== 'Deactivated'}
                  onClick={this.props.trigerResendDialog(email)}
                >
                  Resend invitation
                </ButtonDeactivate>
              </ButtonWrapper>
            </UserProfileDataItem>
          )}
          {values && (
            <Formik
              initialValues={values}
              // onBlur={this.trimOnBlur}
              enableReinitialize
              onSubmit={this.updateUser}
              validationSchema={values && makeSchema(values)}
            >
              {props => (
                <React.Fragment>
                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>First name</UserProfileTitle>
                    <UserProfileValue
                      fullWidth
                      value={props.values.firstName}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'firstName'
                      )}
                      name={'firstName'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.firstName && props.touched.firstName ? (
                      <FieldError>{props.errors.firstName}</FieldError>
                    ) : null}
                  </UserProfileDataItem>
                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>Last name</UserProfileTitle>

                    <UserProfileValue
                      fullWidth
                      value={props.values.lastName}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'lastName'
                      )}
                      name={'lastName'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.lastName && props.touched.lastName ? (
                      <FieldError>{props.errors.lastName}</FieldError>
                    ) : null}
                  </UserProfileDataItem>
                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>
                      {arupUsers ? 'Office address' : 'User address'}
                    </UserProfileTitle>
                    <UserProfileValue
                      fullWidth
                      value={props.values.userAddress}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'userAddress'
                      )}
                      name={'userAddress'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.userAddress && props.touched.userAddress ? (
                      <FieldError>{props.errors.userAddress}</FieldError>
                    ) : null}
                  </UserProfileDataItem>
                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>Email</UserProfileTitle>
                    <UserProfileValue
                      fullWidth
                      value={props.values.email}
                      onChange={this.handleChange(props.setFieldValue, 'email')}
                      name={'email'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.email && props.touched.email ? (
                      <FieldError>{props.errors.email}</FieldError>
                    ) : null}
                  </UserProfileDataItem>
                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>Username</UserProfileTitle>
                    <UserProfileValue
                      fullWidth
                      value={props.values.username}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'username'
                      )}
                      name={'username'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.username && props.touched.username ? (
                      <FieldError>{props.errors.username}</FieldError>
                    ) : null}
                  </UserProfileDataItem>
                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>Phone</UserProfileTitle>

                    <UserProfileValue
                      fullWidth
                      value={props.values.mobile}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'mobile'
                      )}
                      name={'mobile'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.mobile && props.touched.mobile ? (
                      <FieldError>{props.errors.mobile}</FieldError>
                    ) : null}
                  </UserProfileDataItem>

                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>Mobile</UserProfileTitle>

                    <UserProfileValue
                      fullWidth
                      value={props.values.mobileNumber}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'mobileNumber'
                      )}
                      name={'mobileNumber'}
                      onBlur={props.handleBlur}
                    />

                    {props.errors.mobileNumber && props.touched.mobileNumber ? (
                      <FieldError>{props.errors.mobileNumber}</FieldError>
                    ) : null}
                  </UserProfileDataItem>

                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>Workrole</UserProfileTitle>
                    {arupUsers ? (
                      <StyledSelect
                        fullWidth
                        value={props.values.workrole}
                        onChange={this.handleChange(
                          props.setFieldValue,
                          'workrole'
                        )}
                        // displayEmpty
                        name="workrole"
                        // className={classes.selectEmpty}
                      >
                        <MenuItem value={'DESIGNER_LIGHTING'}>
                          Lighting designer
                        </MenuItem>
                        <MenuItem value={'ELECTRICAL_ENGINEER'}>
                          Electrical engineer
                        </MenuItem>
                        <MenuItem value={'ARCHITECT'}>Architect</MenuItem>
                        <MenuItem value={'INTERIOR_DESIGNER'}>
                          Interior designer
                        </MenuItem>
                        <MenuItem value={'AV_DESIGNER'}>AV designer</MenuItem>
                        {/* <MenuItem value={'DESIGNER_ENGINEER'}>
                          Engineer designer
                        </MenuItem> */}
                      </StyledSelect>
                    ) : (
                      <StyledSelect
                        fullWidth
                        value={props.values.workrole}
                        onChange={this.handleChange(
                          props.setFieldValue,
                          'workrole'
                        )}
                        name="workrole"
                      >
                        <MenuItem value={'MANUFACTURER'}>Manufacturer</MenuItem>
                        <MenuItem value={'AGENT'}>Agent</MenuItem>
                        <MenuItem value={'DISTRIBUTOR'}>Distributor</MenuItem>
                        <MenuItem value={'REPRESENTATIVE'}>
                          Representative
                        </MenuItem>
                      </StyledSelect>
                    )}
                    {/* <UserProfileValue
                      fullWidth
                      value={props.values.workrole}
                      onChange={this.handleChange(
                        props.setFieldValue,
                        'workrole'
                      )}
                      name={'workrole'}
                      onBlur={props.handleBlur}
                    /> */}
                    {props.errors.workrole && props.touched.workrole ? (
                      <FieldError>{props.errors.workrole}</FieldError>
                    ) : null}
                  </UserProfileDataItem>
                  {!arupUsers && (
                    <UserProfileDataItem item xs={6}>
                      <UserProfileTitle>Company name</UserProfileTitle>
                      <UserProfileValueNotEditable>
                        {currentUser.companyName
                          ? currentUser.companyName
                          : '-'}
                      </UserProfileValueNotEditable>
                    </UserProfileDataItem>
                  )}

                  {!arupUsers && (
                    <UserProfileDataItem item xs={6}>
                      <UserProfileTitle>Office address </UserProfileTitle>
                      <UserProfileValueNotEditable>
                        {currentUser.officeAddress
                          ? currentUser.officeAddress
                          : '-'}
                      </UserProfileValueNotEditable>
                    </UserProfileDataItem>
                  )}

                  {arupUsers && (
                    <UserProfileDataItem item xs={6}>
                      <UserProfileTitle>Company name</UserProfileTitle>
                      {currentUser.companyId !== 1 ? (
                        <UserProfileValue
                          fullWidth
                          value={props.values.companyName}
                          onChange={this.handleChange(
                            props.setFieldValue,
                            'companyName'
                          )}
                          name={'companyName'}
                          onBlur={props.handleBlur}
                        />
                      ) : (
                        <UserProfileValueNotEditable>
                          {currentUser.companyName
                            ? currentUser.companyName
                            : '-'}
                        </UserProfileValueNotEditable>
                      )}
                      {props.errors.companyName && props.touched.companyName ? (
                        <FieldError>{props.errors.companyName}</FieldError>
                      ) : null}
                    </UserProfileDataItem>
                  )}

                  {arupUsers && (
                    <UserProfileDataItem item xs={6}>
                      <UserProfileTitle>Website</UserProfileTitle>

                      <UserProfileValueNotEditable>
                        {currentUser.companyUrl ? currentUser.companyUrl : '-'}
                      </UserProfileValueNotEditable>
                    </UserProfileDataItem>
                  )}

                  {currentUser &&
                  currentUser.enumWorkrole &&
                  currentUser.enumWorkrole.includes('designer') ? (
                    <React.Fragment>
                      <UserProfileDataItem item xs={6}>
                        <UserProfileTitle>Projects</UserProfileTitle>
                        <UserProfileValueNotEditable>
                          {currentUser.numberOfProjects
                            ? currentUser.numberOfProjects
                            : '-'}
                        </UserProfileValueNotEditable>
                      </UserProfileDataItem>
                      <UserProfileDataItem item xs={6}>
                        <UserProfileTitle>Searches</UserProfileTitle>
                        <UserProfileValueNotEditable>
                          {currentUser.numberOfTickets
                            ? currentUser.numberOfTickets
                            : '-'}
                        </UserProfileValueNotEditable>
                      </UserProfileDataItem>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <UserProfileDataItem item xs={6}>
                        <UserProfileTitle>Slips</UserProfileTitle>
                        <UserProfileValueNotEditable>
                          {currentUser.numberOfSlips
                            ? currentUser.numberOfSlips
                            : '-'}
                        </UserProfileValueNotEditable>
                      </UserProfileDataItem>
                      <UserProfileDataItem item xs={6}>
                        <UserProfileTitle>
                          Specification sheets
                        </UserProfileTitle>
                        <UserProfileValueNotEditable>
                          {currentUser.numberOfSpecificationSheets
                            ? currentUser.numberOfSpecificationSheets
                            : '-'}
                        </UserProfileValueNotEditable>
                      </UserProfileDataItem>
                    </React.Fragment>
                  )}
                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>Joined LB </UserProfileTitle>
                    <UserProfileValueNotEditable>
                      {currentUser.joinedLB
                        ? moment(currentUser.joinedLB).format('LL')
                        : '-'}
                    </UserProfileValueNotEditable>
                  </UserProfileDataItem>

                  <UserProfileDataItem item xs={6}>
                    <UserProfileTitle>Last login date </UserProfileTitle>
                    <UserProfileValueNotEditable>
                      {currentUser.lastLoginDate
                        ? moment(currentUser.lastLoginDate).format('LLL')
                        : '-'}
                    </UserProfileValueNotEditable>
                  </UserProfileDataItem>

                  <UserProfileDataItem item xs={12}>
                    <UserProfileTitle>Action on user</UserProfileTitle>
                    {status === 'Pending_approval' ? (
                      <React.Fragment>
                        <ApproveMsg>This user waits for approval</ApproveMsg>

                        <ButtonWrapper>
                          <ButtonDeactivate
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={status !== 'Pending_approval'}
                            onClick={this.props.trigerOpenApproveDialog(
                              companyId,
                              userId,
                              status
                            )}
                          >
                            Approve
                          </ButtonDeactivate>
                          <ButtonDeactivate
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={status !== 'Pending_approval'}
                            onClick={this.props.trigerOpenDisapproveDialog(
                              companyId,
                              userId,
                              status
                            )}
                          >
                            Decline
                          </ButtonDeactivate>
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={this.props.trigerOpenDeleteDialog(
                              props.values.email
                            )}
                          >
                            DELETE
                          </Button>
                        </ButtonWrapper>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <ButtonWrapper>
                          <ButtonDeactivate
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={
                              status !== 'Active' && status !== 'Deactivated'
                            }
                            onClick={this.props.trigerOpenDeactivateDialog(
                              companyId,
                              userId,
                              status,
                              false
                            )}
                          >
                            {status !== 'Active' ? 'Activate' : 'Deactivate'}
                          </ButtonDeactivate>
                          <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            disabled={
                              status !== 'Active' && status !== 'Deactivated'
                            }
                            onClick={props.handleSubmit}
                          >
                            SAVE
                          </Button>
                        </ButtonWrapper>
                        {status === 'Deactivated' ? (
                          <div>
                            <Button
                              fullWidth
                              variant="contained"
                              color="primary"
                              disabled={
                                status !== 'Active' && status !== 'Deactivated'
                              }
                              onClick={this.props.trigerOpenDeactivateDialog(
                                companyId,
                                userId,
                                status,
                                true
                              )}
                            >
                              deactivate permanently
                            </Button>
                          </div>
                        ) : null}
                        {status === 'Declined' ? (
                          <div>
                            <Button
                              fullWidth
                              variant="contained"
                              color="primary"
                              onClick={this.props.trigerOpenDeleteDialog(
                                props.values.email
                              )}
                            >
                              Delete
                            </Button>
                          </div>
                        ) : null}
                      </React.Fragment>
                    )}
                  </UserProfileDataItem>
                </React.Fragment>
              )}
            </Formik>
          )}
        </UserProfileData>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          key={`${'bottom'},${'left'}`}
          open={this.state.open}
          onClose={this.handleCloseSnack}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.state.message}</span>}
          action={
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleCloseSnack}
            >
              <CloseIcon />
            </IconButton>
          }
        />
      </UserProfileWrapper>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getSingleAdminUserData: (userId, companyId) => {
    dispatch(getSingleAdminUserData(userId, companyId));
  },
});
const mapStateToProps = store => {
  return {
    currentUser: store.adminData.currentUser,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
